import React from 'react';
import { Link } from 'react-router-dom';
import './Navigation.css';

const Navigation = () => {
  return (
    <nav className="navigation">
      <div className="nav-row top-row">
        <Link to="/album-preview" className="nav-link">ALBUM PREVIEW</Link>
        <Link to="/film-music" className="nav-link">FILM MUSIC</Link>
        <Link to="/gallery" className="nav-link">GALLERY</Link>
        <Link to="/biography" className="nav-link">BIOGRAPHY</Link>
      </div>
      <div className="nav-row bottom-row">
        <Link to="/reviews" className="nav-link">REVIEWS</Link>
        <Link to="/contact" className="nav-link">CONTACT</Link>
      </div>
    </nav>
  );
};

export default Navigation;